unit View.Servicos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils;

type
  TFViewServicosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbservico_preco: TLabel;
    edservico_preco: TDBEdit;
    lbcusto_fixo: TLabel;
    lbunidade_id: TLabel;
    edunidade_id: TDBEdit;
    lbtipo_servico_codigo: TLabel;
    edtipo_servico_codigo: TDBEdit;
    lbservico_comissao: TLabel;
    edservico_comissao: TDBEdit;
    lbstatus_id: TLabel;
    edstatus_id: TDBEdit;
    lbservico_preco_custo: TLabel;
    edservico_preco_custo: TDBEdit;
    lbservico_terceiro: TLabel;
    lbservico_desconto_maximo: TLabel;
    edservico_desconto_maximo: TDBEdit;
    lbservico_garantia: TLabel;
    edservico_garantia: TDBEdit;
    lbservico_ciclo_vida: TLabel;
    edservico_ciclo_vida: TDBEdit;
    lbservicos_nacional_id: TLabel;
    edservicos_nacional_id: TDBEdit;
    lbnbs_id: TLabel;
    ednbs_id: TDBEdit;
    lbcodigo_issqn: TLabel;
    edcodigo_issqn: TDBEdit;
    lbcodigo_tributacao_municipio: TLabel;
    edcodigo_tributacao_municipio: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientServicosGet: TXDataWebClient;
    ServicosDataset: TXDataWebDataSet;
    ServicosDatasetid: TIntegerField;
    ServicosDatasetaliado_id: TIntegerField;
    ServicosDatasetdata_base_id: TIntegerField;
    ServicosDatasetnome: TStringField;
    ServicosDatasetservico_preco: TFloatField;
    ServicosDatasetcusto_fixo: TBooleanField;
    ServicosDatasetunidade_id: TIntegerField;
    ServicosDatasettipo_servico_codigo: TStringField;
    ServicosDatasetservico_comissao: TFloatField;
    ServicosDatasetdepartamento_id: TIntegerField;
    ServicosDatasetstatus_id: TIntegerField;
    ServicosDatasetservico_preco_custo: TFloatField;
    ServicosDatasetservico_terceiro: TBooleanField;
    ServicosDatasetservico_desconto_maximo: TFloatField;
    ServicosDatasetservico_garantia: TIntegerField;
    ServicosDatasetservico_ciclo_vida: TIntegerField;
    ServicosDatasetservicos_nacional_id: TIntegerField;
    ServicosDatasetnbs_id: TIntegerField;
    ServicosDatasetcodigo_issqn: TStringField;
    ServicosDatasetcodigo_tributacao_municipio: TStringField;
    ServicosDatasetcodigo_interno: TIntegerField;
    ServicosDatasetexcluido: TBooleanField;
    ServicosDatasetinclusao: TDateTimeField;
    ServicosDatasetalteracao: TDateTimeField;
    ServicosDatasetexclusao: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxcustofixo: TDBCheckBox;
    cbxservicoterceiro: TDBCheckBox;
    ServicosDatasetunidadesigla: TStringField;
    ServicosDatasetnbsnbs: TStringField;
    ServicosDatasetnbsdescricao: TStringField;
    ServicosDatasetserv_nacionalcTribNac: TStringField;
    ServicosDatasetserv_nacionaldescricao: TStringField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientServicosGetLoad(Response: TXDataClientResponse);
    procedure ServicosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure ServicosDatasetnbsnbsGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ServicosDatasetserv_nacionalcTribNacGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure ServicosDatasetstatus_idGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewServicosEdit: TFViewServicosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewServicosEdit }

class function TFViewServicosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewServicosEdit.InsertEntity;
begin
  ServicosDataset.Close;
  ServicosDataset.SetJsonData('{}');
  ServicosDataset.Open;
  ServicosDataset.Insert;
end;

class function TFViewServicosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewServicosEdit(AForm).FInserting := AInserting;
    TFViewServicosEdit(AForm).FId := AId;
    TFViewServicosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewServicosEdit(AForm).InsertEntity
    else
      TFViewServicosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewServicosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewServicosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ServicosDataset.Connection.Model.DefaultSchema.FindEntityType(
      ServicosDataset.EntitySetName
    )
  );
  XDataClientServicosGet.Get(ServicosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewServicosEdit.XDataClientServicosGetLoad(Response: TXDataClientResponse);
begin
  ServicosDataset.Close;
  ServicosDataset.SetJsonData(Response.Result);
  ServicosDataset.Open;
  
  ServicosDataset.Edit;  
end;

procedure TFViewServicosEdit.ServicosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewServicosEdit.ServicosDatasetnbsnbsGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := Sender.AsString + ' - ' + ServicosDataset.FieldByName('nbs.descricao').AsString;
end;

procedure TFViewServicosEdit.ServicosDatasetserv_nacionalcTribNacGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := Sender.AsString + ' - ' + ServicosDataset.FieldByName('serv_nacional.descricao').AsString;
end;

procedure TFViewServicosEdit.ServicosDatasetstatus_idGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.GetNomeStatusFornecedor(Sender.AsInteger);
end;

procedure TFViewServicosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewServicosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.servicos.form.lbid');
  lbnome := TLabel.Create('view.servicos.form.lbnome');
  lbservico_preco := TLabel.Create('view.servicos.form.lbservico_preco');
  lbcusto_fixo := TLabel.Create('view.servicos.form.lbcusto_fixo');
  lbunidade_id := TLabel.Create('view.servicos.form.lbunidade_id');
  lbtipo_servico_codigo := TLabel.Create('view.servicos.form.lbtipo_servico_codigo');
  lbservico_comissao := TLabel.Create('view.servicos.form.lbservico_comissao');
  lbstatus_id := TLabel.Create('view.servicos.form.lbstatus_id');
  lbservico_preco_custo := TLabel.Create('view.servicos.form.lbservico_preco_custo');
  lbservico_terceiro := TLabel.Create('view.servicos.form.lbservico_terceiro');
  lbservico_desconto_maximo := TLabel.Create('view.servicos.form.lbservico_desconto_maximo');
  lbservico_garantia := TLabel.Create('view.servicos.form.lbservico_garantia');
  lbservico_ciclo_vida := TLabel.Create('view.servicos.form.lbservico_ciclo_vida');
  lbservicos_nacional_id := TLabel.Create('view.servicos.form.lbservicos_nacional_id');
  lbnbs_id := TLabel.Create('view.servicos.form.lbnbs_id');
  lbcodigo_issqn := TLabel.Create('view.servicos.form.lbcodigo_issqn');
  lbcodigo_tributacao_municipio := TLabel.Create('view.servicos.form.lbcodigo_tributacao_municipio');
  lbcodigo_interno := TLabel.Create('view.servicos.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.servicos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.servicos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.servicos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.servicos.form.lbexclusao');
  btCancel := TButton.Create('view.servicos.form.btBack');
  edid := TDBEdit.Create('view.servicos.form.edid');
  ednome := TDBEdit.Create('view.servicos.form.ednome');
  edservico_preco := TDBEdit.Create('view.servicos.form.edservico_preco');
  edunidade_id := TDBEdit.Create('view.servicos.form.edunidade_id');
  edtipo_servico_codigo := TDBEdit.Create('view.servicos.form.edtipo_servico_codigo');
  edservico_comissao := TDBEdit.Create('view.servicos.form.edservico_comissao');
  edstatus_id := TDBEdit.Create('view.servicos.form.edstatus_id');
  edservico_preco_custo := TDBEdit.Create('view.servicos.form.edservico_preco_custo');
  edservico_desconto_maximo := TDBEdit.Create('view.servicos.form.edservico_desconto_maximo');
  edservico_garantia := TDBEdit.Create('view.servicos.form.edservico_garantia');
  edservico_ciclo_vida := TDBEdit.Create('view.servicos.form.edservico_ciclo_vida');
  edservicos_nacional_id := TDBEdit.Create('view.servicos.form.edservicos_nacional_id');
  ednbs_id := TDBEdit.Create('view.servicos.form.ednbs_id');
  edcodigo_issqn := TDBEdit.Create('view.servicos.form.edcodigo_issqn');
  edcodigo_tributacao_municipio := TDBEdit.Create('view.servicos.form.edcodigo_tributacao_municipio');
  edcodigo_interno := TDBEdit.Create('view.servicos.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.servicos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.servicos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.servicos.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.servicos.form.cbxexcluido');
  cbxcustofixo := TDBCheckBox.Create('view.servicos.form.cbxcustofixo');
  cbxservicoterceiro := TDBCheckBox.Create('view.servicos.form.cbxservicoterceiro');
  DataSource := TDataSource.Create(Self);
  ServicosDataset := TXDataWebDataSet.Create(Self);
  ServicosDatasetid := TIntegerField.Create(Self);
  ServicosDatasetaliado_id := TIntegerField.Create(Self);
  ServicosDatasetdata_base_id := TIntegerField.Create(Self);
  ServicosDatasetnome := TStringField.Create(Self);
  ServicosDatasetservico_preco := TFloatField.Create(Self);
  ServicosDatasetcusto_fixo := TBooleanField.Create(Self);
  ServicosDatasetunidade_id := TIntegerField.Create(Self);
  ServicosDatasettipo_servico_codigo := TStringField.Create(Self);
  ServicosDatasetservico_comissao := TFloatField.Create(Self);
  ServicosDatasetdepartamento_id := TIntegerField.Create(Self);
  ServicosDatasetstatus_id := TIntegerField.Create(Self);
  ServicosDatasetservico_preco_custo := TFloatField.Create(Self);
  ServicosDatasetservico_terceiro := TBooleanField.Create(Self);
  ServicosDatasetservico_desconto_maximo := TFloatField.Create(Self);
  ServicosDatasetservico_garantia := TIntegerField.Create(Self);
  ServicosDatasetservico_ciclo_vida := TIntegerField.Create(Self);
  ServicosDatasetservicos_nacional_id := TIntegerField.Create(Self);
  ServicosDatasetnbs_id := TIntegerField.Create(Self);
  ServicosDatasetcodigo_issqn := TStringField.Create(Self);
  ServicosDatasetcodigo_tributacao_municipio := TStringField.Create(Self);
  ServicosDatasetcodigo_interno := TIntegerField.Create(Self);
  ServicosDatasetexcluido := TBooleanField.Create(Self);
  ServicosDatasetinclusao := TDateTimeField.Create(Self);
  ServicosDatasetalteracao := TDateTimeField.Create(Self);
  ServicosDatasetexclusao := TDateTimeField.Create(Self);
  ServicosDatasetunidadesigla := TStringField.Create(Self);
  ServicosDatasetnbsnbs := TStringField.Create(Self);
  ServicosDatasetnbsdescricao := TStringField.Create(Self);
  ServicosDatasetserv_nacionalcTribNac := TStringField.Create(Self);
  ServicosDatasetserv_nacionaldescricao := TStringField.Create(Self);
  XDataClientServicosGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbservico_preco.BeforeLoadDFMValues;
  lbcusto_fixo.BeforeLoadDFMValues;
  lbunidade_id.BeforeLoadDFMValues;
  lbtipo_servico_codigo.BeforeLoadDFMValues;
  lbservico_comissao.BeforeLoadDFMValues;
  lbstatus_id.BeforeLoadDFMValues;
  lbservico_preco_custo.BeforeLoadDFMValues;
  lbservico_terceiro.BeforeLoadDFMValues;
  lbservico_desconto_maximo.BeforeLoadDFMValues;
  lbservico_garantia.BeforeLoadDFMValues;
  lbservico_ciclo_vida.BeforeLoadDFMValues;
  lbservicos_nacional_id.BeforeLoadDFMValues;
  lbnbs_id.BeforeLoadDFMValues;
  lbcodigo_issqn.BeforeLoadDFMValues;
  lbcodigo_tributacao_municipio.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edservico_preco.BeforeLoadDFMValues;
  edunidade_id.BeforeLoadDFMValues;
  edtipo_servico_codigo.BeforeLoadDFMValues;
  edservico_comissao.BeforeLoadDFMValues;
  edstatus_id.BeforeLoadDFMValues;
  edservico_preco_custo.BeforeLoadDFMValues;
  edservico_desconto_maximo.BeforeLoadDFMValues;
  edservico_garantia.BeforeLoadDFMValues;
  edservico_ciclo_vida.BeforeLoadDFMValues;
  edservicos_nacional_id.BeforeLoadDFMValues;
  ednbs_id.BeforeLoadDFMValues;
  edcodigo_issqn.BeforeLoadDFMValues;
  edcodigo_tributacao_municipio.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxcustofixo.BeforeLoadDFMValues;
  cbxservicoterceiro.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ServicosDataset.BeforeLoadDFMValues;
  ServicosDatasetid.BeforeLoadDFMValues;
  ServicosDatasetaliado_id.BeforeLoadDFMValues;
  ServicosDatasetdata_base_id.BeforeLoadDFMValues;
  ServicosDatasetnome.BeforeLoadDFMValues;
  ServicosDatasetservico_preco.BeforeLoadDFMValues;
  ServicosDatasetcusto_fixo.BeforeLoadDFMValues;
  ServicosDatasetunidade_id.BeforeLoadDFMValues;
  ServicosDatasettipo_servico_codigo.BeforeLoadDFMValues;
  ServicosDatasetservico_comissao.BeforeLoadDFMValues;
  ServicosDatasetdepartamento_id.BeforeLoadDFMValues;
  ServicosDatasetstatus_id.BeforeLoadDFMValues;
  ServicosDatasetservico_preco_custo.BeforeLoadDFMValues;
  ServicosDatasetservico_terceiro.BeforeLoadDFMValues;
  ServicosDatasetservico_desconto_maximo.BeforeLoadDFMValues;
  ServicosDatasetservico_garantia.BeforeLoadDFMValues;
  ServicosDatasetservico_ciclo_vida.BeforeLoadDFMValues;
  ServicosDatasetservicos_nacional_id.BeforeLoadDFMValues;
  ServicosDatasetnbs_id.BeforeLoadDFMValues;
  ServicosDatasetcodigo_issqn.BeforeLoadDFMValues;
  ServicosDatasetcodigo_tributacao_municipio.BeforeLoadDFMValues;
  ServicosDatasetcodigo_interno.BeforeLoadDFMValues;
  ServicosDatasetexcluido.BeforeLoadDFMValues;
  ServicosDatasetinclusao.BeforeLoadDFMValues;
  ServicosDatasetalteracao.BeforeLoadDFMValues;
  ServicosDatasetexclusao.BeforeLoadDFMValues;
  ServicosDatasetunidadesigla.BeforeLoadDFMValues;
  ServicosDatasetnbsnbs.BeforeLoadDFMValues;
  ServicosDatasetnbsdescricao.BeforeLoadDFMValues;
  ServicosDatasetserv_nacionalcTribNac.BeforeLoadDFMValues;
  ServicosDatasetserv_nacionaldescricao.BeforeLoadDFMValues;
  XDataClientServicosGet.BeforeLoadDFMValues;
  try
    Name := 'FViewServicosEdit';
    Width := 613;
    Height := 420;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 16;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 45;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbservico_preco.SetParentComponent(Self);
    lbservico_preco.Name := 'lbservico_preco';
    lbservico_preco.Left := 24;
    lbservico_preco.Top := 72;
    lbservico_preco.Width := 31;
    lbservico_preco.Height := 13;
    lbservico_preco.Caption := 'Pre'#231'o:';
    lbservico_preco.HeightPercent := 100.000000000000000000;
    lbservico_preco.WidthPercent := 100.000000000000000000;
    lbcusto_fixo.SetParentComponent(Self);
    lbcusto_fixo.Name := 'lbcusto_fixo';
    lbcusto_fixo.Left := 24;
    lbcusto_fixo.Top := 99;
    lbcusto_fixo.Width := 56;
    lbcusto_fixo.Height := 13;
    lbcusto_fixo.Caption := 'Custo Fixo?';
    lbcusto_fixo.HeightPercent := 100.000000000000000000;
    lbcusto_fixo.WidthPercent := 100.000000000000000000;
    lbunidade_id.SetParentComponent(Self);
    lbunidade_id.Name := 'lbunidade_id';
    lbunidade_id.Left := 24;
    lbunidade_id.Top := 126;
    lbunidade_id.Width := 43;
    lbunidade_id.Height := 13;
    lbunidade_id.Caption := 'Unidade:';
    lbunidade_id.HeightPercent := 100.000000000000000000;
    lbunidade_id.WidthPercent := 100.000000000000000000;
    lbtipo_servico_codigo.SetParentComponent(Self);
    lbtipo_servico_codigo.Name := 'lbtipo_servico_codigo';
    lbtipo_servico_codigo.Left := 24;
    lbtipo_servico_codigo.Top := 153;
    lbtipo_servico_codigo.Width := 79;
    lbtipo_servico_codigo.Height := 13;
    lbtipo_servico_codigo.Caption := 'Tipo Serv. C'#243'd.:';
    lbtipo_servico_codigo.HeightPercent := 100.000000000000000000;
    lbtipo_servico_codigo.WidthPercent := 100.000000000000000000;
    lbservico_comissao.SetParentComponent(Self);
    lbservico_comissao.Name := 'lbservico_comissao';
    lbservico_comissao.Left := 24;
    lbservico_comissao.Top := 180;
    lbservico_comissao.Width := 49;
    lbservico_comissao.Height := 13;
    lbservico_comissao.Caption := 'Comiss'#227'o:';
    lbservico_comissao.HeightPercent := 100.000000000000000000;
    lbservico_comissao.WidthPercent := 100.000000000000000000;
    lbstatus_id.SetParentComponent(Self);
    lbstatus_id.Name := 'lbstatus_id';
    lbstatus_id.Left := 24;
    lbstatus_id.Top := 206;
    lbstatus_id.Width := 35;
    lbstatus_id.Height := 13;
    lbstatus_id.Caption := 'Status:';
    lbstatus_id.HeightPercent := 100.000000000000000000;
    lbstatus_id.WidthPercent := 100.000000000000000000;
    lbservico_preco_custo.SetParentComponent(Self);
    lbservico_preco_custo.Name := 'lbservico_preco_custo';
    lbservico_preco_custo.Left := 24;
    lbservico_preco_custo.Top := 233;
    lbservico_preco_custo.Width := 62;
    lbservico_preco_custo.Height := 13;
    lbservico_preco_custo.Caption := 'Pre'#231'o Custo:';
    lbservico_preco_custo.HeightPercent := 100.000000000000000000;
    lbservico_preco_custo.WidthPercent := 100.000000000000000000;
    lbservico_terceiro.SetParentComponent(Self);
    lbservico_terceiro.Name := 'lbservico_terceiro';
    lbservico_terceiro.Left := 24;
    lbservico_terceiro.Top := 260;
    lbservico_terceiro.Width := 82;
    lbservico_terceiro.Height := 13;
    lbservico_terceiro.Caption := 'Servi'#231'o Terceiro?';
    lbservico_terceiro.HeightPercent := 100.000000000000000000;
    lbservico_terceiro.WidthPercent := 100.000000000000000000;
    lbservico_desconto_maximo.SetParentComponent(Self);
    lbservico_desconto_maximo.Name := 'lbservico_desconto_maximo';
    lbservico_desconto_maximo.Left := 24;
    lbservico_desconto_maximo.Top := 287;
    lbservico_desconto_maximo.Width := 88;
    lbservico_desconto_maximo.Height := 13;
    lbservico_desconto_maximo.Caption := 'Desconto M'#225'ximo:';
    lbservico_desconto_maximo.HeightPercent := 100.000000000000000000;
    lbservico_desconto_maximo.WidthPercent := 100.000000000000000000;
    lbservico_garantia.SetParentComponent(Self);
    lbservico_garantia.Name := 'lbservico_garantia';
    lbservico_garantia.Left := 352;
    lbservico_garantia.Top := 233;
    lbservico_garantia.Width := 76;
    lbservico_garantia.Height := 13;
    lbservico_garantia.Caption := 'Garantia (Dias):';
    lbservico_garantia.HeightPercent := 100.000000000000000000;
    lbservico_garantia.WidthPercent := 100.000000000000000000;
    lbservico_ciclo_vida.SetParentComponent(Self);
    lbservico_ciclo_vida.Name := 'lbservico_ciclo_vida';
    lbservico_ciclo_vida.Left := 352;
    lbservico_ciclo_vida.Top := 260;
    lbservico_ciclo_vida.Width := 49;
    lbservico_ciclo_vida.Height := 13;
    lbservico_ciclo_vida.Caption := 'Ciclo Vida:';
    lbservico_ciclo_vida.HeightPercent := 100.000000000000000000;
    lbservico_ciclo_vida.WidthPercent := 100.000000000000000000;
    lbservicos_nacional_id.SetParentComponent(Self);
    lbservicos_nacional_id.Name := 'lbservicos_nacional_id';
    lbservicos_nacional_id.Left := 352;
    lbservicos_nacional_id.Top := 287;
    lbservicos_nacional_id.Width := 82;
    lbservicos_nacional_id.Height := 13;
    lbservicos_nacional_id.Caption := 'Servi'#231'o Nacional:';
    lbservicos_nacional_id.HeightPercent := 100.000000000000000000;
    lbservicos_nacional_id.WidthPercent := 100.000000000000000000;
    lbnbs_id.SetParentComponent(Self);
    lbnbs_id.Name := 'lbnbs_id';
    lbnbs_id.Left := 352;
    lbnbs_id.Top := 16;
    lbnbs_id.Width := 23;
    lbnbs_id.Height := 13;
    lbnbs_id.Caption := 'NBS:';
    lbnbs_id.HeightPercent := 100.000000000000000000;
    lbnbs_id.WidthPercent := 100.000000000000000000;
    lbcodigo_issqn.SetParentComponent(Self);
    lbcodigo_issqn.Name := 'lbcodigo_issqn';
    lbcodigo_issqn.Left := 352;
    lbcodigo_issqn.Top := 43;
    lbcodigo_issqn.Width := 61;
    lbcodigo_issqn.Height := 13;
    lbcodigo_issqn.Caption := 'C'#243'd. ISSQN:';
    lbcodigo_issqn.HeightPercent := 100.000000000000000000;
    lbcodigo_issqn.WidthPercent := 100.000000000000000000;
    lbcodigo_tributacao_municipio.SetParentComponent(Self);
    lbcodigo_tributacao_municipio.Name := 'lbcodigo_tributacao_municipio';
    lbcodigo_tributacao_municipio.Left := 352;
    lbcodigo_tributacao_municipio.Top := 70;
    lbcodigo_tributacao_municipio.Width := 86;
    lbcodigo_tributacao_municipio.Height := 13;
    lbcodigo_tributacao_municipio.Caption := 'C'#243'd. Trib. Munic.:';
    lbcodigo_tributacao_municipio.HeightPercent := 100.000000000000000000;
    lbcodigo_tributacao_municipio.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 352;
    lbcodigo_interno.Top := 97;
    lbcodigo_interno.Width := 51;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret.:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 352;
    lbexcluido.Top := 124;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 352;
    lbinclusao.Top := 151;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 352;
    lbalteracao.Top := 178;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 352;
    lbexclusao.Top := 205;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 24;
    btCancel.Top := 336;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 141;
    edid.Top := 13;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 141;
    ednome.Top := 42;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edservico_preco.SetParentComponent(Self);
    edservico_preco.Name := 'edservico_preco';
    edservico_preco.Left := 141;
    edservico_preco.Top := 69;
    edservico_preco.Width := 120;
    edservico_preco.Height := 21;
    edservico_preco.Enabled := False;
    edservico_preco.HeightPercent := 100.000000000000000000;
    edservico_preco.TabOrder := 10;
    edservico_preco.Text := 'edservico_preco';
    edservico_preco.WidthPercent := 100.000000000000000000;
    edservico_preco.DataField := 'servico_preco';
    edservico_preco.DataSource := DataSource;
    edunidade_id.SetParentComponent(Self);
    edunidade_id.Name := 'edunidade_id';
    edunidade_id.Left := 141;
    edunidade_id.Top := 123;
    edunidade_id.Width := 120;
    edunidade_id.Height := 21;
    edunidade_id.Enabled := False;
    edunidade_id.HeightPercent := 100.000000000000000000;
    edunidade_id.TabOrder := 12;
    edunidade_id.Text := 'edunidade_id';
    edunidade_id.WidthPercent := 100.000000000000000000;
    edunidade_id.DataField := 'unidade.sigla';
    edunidade_id.DataSource := DataSource;
    edtipo_servico_codigo.SetParentComponent(Self);
    edtipo_servico_codigo.Name := 'edtipo_servico_codigo';
    edtipo_servico_codigo.Left := 141;
    edtipo_servico_codigo.Top := 150;
    edtipo_servico_codigo.Width := 120;
    edtipo_servico_codigo.Height := 21;
    edtipo_servico_codigo.Enabled := False;
    edtipo_servico_codigo.HeightPercent := 100.000000000000000000;
    edtipo_servico_codigo.TabOrder := 13;
    edtipo_servico_codigo.Text := 'edtipo_servico_codigo';
    edtipo_servico_codigo.WidthPercent := 100.000000000000000000;
    edtipo_servico_codigo.DataField := 'tipo_servico_codigo';
    edtipo_servico_codigo.DataSource := DataSource;
    edservico_comissao.SetParentComponent(Self);
    edservico_comissao.Name := 'edservico_comissao';
    edservico_comissao.Left := 141;
    edservico_comissao.Top := 177;
    edservico_comissao.Width := 120;
    edservico_comissao.Height := 21;
    edservico_comissao.Enabled := False;
    edservico_comissao.HeightPercent := 100.000000000000000000;
    edservico_comissao.TabOrder := 14;
    edservico_comissao.Text := 'edservico_comissao';
    edservico_comissao.WidthPercent := 100.000000000000000000;
    edservico_comissao.DataField := 'servico_comissao';
    edservico_comissao.DataSource := DataSource;
    edstatus_id.SetParentComponent(Self);
    edstatus_id.Name := 'edstatus_id';
    edstatus_id.Left := 141;
    edstatus_id.Top := 203;
    edstatus_id.Width := 120;
    edstatus_id.Height := 21;
    edstatus_id.Enabled := False;
    edstatus_id.HeightPercent := 100.000000000000000000;
    edstatus_id.TabOrder := 16;
    edstatus_id.Text := 'edstatus_id';
    edstatus_id.WidthPercent := 100.000000000000000000;
    edstatus_id.DataField := 'status_id';
    edstatus_id.DataSource := DataSource;
    edservico_preco_custo.SetParentComponent(Self);
    edservico_preco_custo.Name := 'edservico_preco_custo';
    edservico_preco_custo.Left := 141;
    edservico_preco_custo.Top := 230;
    edservico_preco_custo.Width := 120;
    edservico_preco_custo.Height := 21;
    edservico_preco_custo.Enabled := False;
    edservico_preco_custo.HeightPercent := 100.000000000000000000;
    edservico_preco_custo.TabOrder := 17;
    edservico_preco_custo.Text := 'edservico_preco_custo';
    edservico_preco_custo.WidthPercent := 100.000000000000000000;
    edservico_preco_custo.DataField := 'servico_preco_custo';
    edservico_preco_custo.DataSource := DataSource;
    edservico_desconto_maximo.SetParentComponent(Self);
    edservico_desconto_maximo.Name := 'edservico_desconto_maximo';
    edservico_desconto_maximo.Left := 141;
    edservico_desconto_maximo.Top := 284;
    edservico_desconto_maximo.Width := 120;
    edservico_desconto_maximo.Height := 21;
    edservico_desconto_maximo.Enabled := False;
    edservico_desconto_maximo.HeightPercent := 100.000000000000000000;
    edservico_desconto_maximo.TabOrder := 19;
    edservico_desconto_maximo.Text := 'edservico_desconto_maximo';
    edservico_desconto_maximo.WidthPercent := 100.000000000000000000;
    edservico_desconto_maximo.DataField := 'servico_desconto_maximo';
    edservico_desconto_maximo.DataSource := DataSource;
    edservico_garantia.SetParentComponent(Self);
    edservico_garantia.Name := 'edservico_garantia';
    edservico_garantia.Left := 469;
    edservico_garantia.Top := 230;
    edservico_garantia.Width := 120;
    edservico_garantia.Height := 21;
    edservico_garantia.Enabled := False;
    edservico_garantia.HeightPercent := 100.000000000000000000;
    edservico_garantia.TabOrder := 20;
    edservico_garantia.Text := 'edservico_garantia';
    edservico_garantia.WidthPercent := 100.000000000000000000;
    edservico_garantia.DataField := 'servico_garantia';
    edservico_garantia.DataSource := DataSource;
    edservico_ciclo_vida.SetParentComponent(Self);
    edservico_ciclo_vida.Name := 'edservico_ciclo_vida';
    edservico_ciclo_vida.Left := 469;
    edservico_ciclo_vida.Top := 257;
    edservico_ciclo_vida.Width := 120;
    edservico_ciclo_vida.Height := 21;
    edservico_ciclo_vida.Enabled := False;
    edservico_ciclo_vida.HeightPercent := 100.000000000000000000;
    edservico_ciclo_vida.TabOrder := 21;
    edservico_ciclo_vida.Text := 'edservico_ciclo_vida';
    edservico_ciclo_vida.WidthPercent := 100.000000000000000000;
    edservico_ciclo_vida.DataField := 'servico_ciclo_vida';
    edservico_ciclo_vida.DataSource := DataSource;
    edservicos_nacional_id.SetParentComponent(Self);
    edservicos_nacional_id.Name := 'edservicos_nacional_id';
    edservicos_nacional_id.Left := 469;
    edservicos_nacional_id.Top := 284;
    edservicos_nacional_id.Width := 120;
    edservicos_nacional_id.Height := 21;
    edservicos_nacional_id.Enabled := False;
    edservicos_nacional_id.HeightPercent := 100.000000000000000000;
    edservicos_nacional_id.TabOrder := 22;
    edservicos_nacional_id.Text := 'edservicos_nacional_id';
    edservicos_nacional_id.WidthPercent := 100.000000000000000000;
    edservicos_nacional_id.DataField := 'serv_nacional.cTribNac';
    edservicos_nacional_id.DataSource := DataSource;
    ednbs_id.SetParentComponent(Self);
    ednbs_id.Name := 'ednbs_id';
    ednbs_id.Left := 469;
    ednbs_id.Top := 13;
    ednbs_id.Width := 120;
    ednbs_id.Height := 21;
    ednbs_id.Enabled := False;
    ednbs_id.HeightPercent := 100.000000000000000000;
    ednbs_id.TabOrder := 23;
    ednbs_id.Text := 'ednbs_id';
    ednbs_id.WidthPercent := 100.000000000000000000;
    ednbs_id.DataField := 'nbs.nbs';
    ednbs_id.DataSource := DataSource;
    edcodigo_issqn.SetParentComponent(Self);
    edcodigo_issqn.Name := 'edcodigo_issqn';
    edcodigo_issqn.Left := 469;
    edcodigo_issqn.Top := 40;
    edcodigo_issqn.Width := 120;
    edcodigo_issqn.Height := 21;
    edcodigo_issqn.Enabled := False;
    edcodigo_issqn.HeightPercent := 100.000000000000000000;
    edcodigo_issqn.TabOrder := 24;
    edcodigo_issqn.Text := 'edcodigo_issqn';
    edcodigo_issqn.WidthPercent := 100.000000000000000000;
    edcodigo_issqn.DataField := 'codigo_issqn';
    edcodigo_issqn.DataSource := DataSource;
    edcodigo_tributacao_municipio.SetParentComponent(Self);
    edcodigo_tributacao_municipio.Name := 'edcodigo_tributacao_municipio';
    edcodigo_tributacao_municipio.Left := 469;
    edcodigo_tributacao_municipio.Top := 67;
    edcodigo_tributacao_municipio.Width := 120;
    edcodigo_tributacao_municipio.Height := 21;
    edcodigo_tributacao_municipio.Enabled := False;
    edcodigo_tributacao_municipio.HeightPercent := 100.000000000000000000;
    edcodigo_tributacao_municipio.TabOrder := 25;
    edcodigo_tributacao_municipio.Text := 'edcodigo_tributacao_municipio';
    edcodigo_tributacao_municipio.WidthPercent := 100.000000000000000000;
    edcodigo_tributacao_municipio.DataField := 'codigo_tributacao_municipio';
    edcodigo_tributacao_municipio.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 469;
    edcodigo_interno.Top := 94;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 26;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 469;
    edinclusao.Top := 148;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 28;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 469;
    edalteracao.Top := 175;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 29;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 469;
    edexclusao.Top := 202;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 30;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 469;
    cbxexcluido.Top := 121;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxcustofixo.SetParentComponent(Self);
    cbxcustofixo.Name := 'cbxcustofixo';
    cbxcustofixo.Left := 141;
    cbxcustofixo.Top := 96;
    cbxcustofixo.Width := 120;
    cbxcustofixo.Height := 22;
    cbxcustofixo.Caption := 'cbxcustofixo';
    cbxcustofixo.ChildOrder := 33;
    cbxcustofixo.Enabled := False;
    cbxcustofixo.HeightPercent := 100.000000000000000000;
    cbxcustofixo.WidthPercent := 100.000000000000000000;
    cbxcustofixo.DataField := 'custo_fixo';
    cbxcustofixo.DataSource := DataSource;
    cbxservicoterceiro.SetParentComponent(Self);
    cbxservicoterceiro.Name := 'cbxservicoterceiro';
    cbxservicoterceiro.Left := 141;
    cbxservicoterceiro.Top := 257;
    cbxservicoterceiro.Width := 120;
    cbxservicoterceiro.Height := 22;
    cbxservicoterceiro.Caption := 'cbxservicoterceiro';
    cbxservicoterceiro.ChildOrder := 33;
    cbxservicoterceiro.Enabled := False;
    cbxservicoterceiro.HeightPercent := 100.000000000000000000;
    cbxservicoterceiro.WidthPercent := 100.000000000000000000;
    cbxservicoterceiro.DataField := 'servico_terceiro';
    cbxservicoterceiro.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ServicosDataset;
    DataSource.Left := 336;
    DataSource.Top := 328;
    ServicosDataset.SetParentComponent(Self);
    ServicosDataset.Name := 'ServicosDataset';
    ServicosDataset.AfterApplyUpdates := ServicosDatasetAfterApplyUpdates;
    ServicosDataset.EntitySetName := 'Servicos';
    ServicosDataset.Connection := DMConnection.ApiConnection;
    ServicosDataset.Left := 256;
    ServicosDataset.Top := 328;
    ServicosDatasetid.SetParentComponent(ServicosDataset);
    ServicosDatasetid.Name := 'ServicosDatasetid';
    ServicosDatasetid.FieldName := 'id';
    ServicosDatasetid.Required := True;
    ServicosDatasetaliado_id.SetParentComponent(ServicosDataset);
    ServicosDatasetaliado_id.Name := 'ServicosDatasetaliado_id';
    ServicosDatasetaliado_id.FieldName := 'aliado_id';
    ServicosDatasetaliado_id.Required := True;
    ServicosDatasetdata_base_id.SetParentComponent(ServicosDataset);
    ServicosDatasetdata_base_id.Name := 'ServicosDatasetdata_base_id';
    ServicosDatasetdata_base_id.FieldName := 'data_base_id';
    ServicosDatasetdata_base_id.Required := True;
    ServicosDatasetnome.SetParentComponent(ServicosDataset);
    ServicosDatasetnome.Name := 'ServicosDatasetnome';
    ServicosDatasetnome.FieldName := 'nome';
    ServicosDatasetnome.Required := True;
    ServicosDatasetnome.Size := 255;
    ServicosDatasetservico_preco.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_preco.Name := 'ServicosDatasetservico_preco';
    ServicosDatasetservico_preco.FieldName := 'servico_preco';
    ServicosDatasetservico_preco.DisplayFormat := '#,##0.00';
    ServicosDatasetcusto_fixo.SetParentComponent(ServicosDataset);
    ServicosDatasetcusto_fixo.Name := 'ServicosDatasetcusto_fixo';
    ServicosDatasetcusto_fixo.FieldName := 'custo_fixo';
    ServicosDatasetcusto_fixo.Required := True;
    ServicosDatasetunidade_id.SetParentComponent(ServicosDataset);
    ServicosDatasetunidade_id.Name := 'ServicosDatasetunidade_id';
    ServicosDatasetunidade_id.FieldName := 'unidade_id';
    ServicosDatasettipo_servico_codigo.SetParentComponent(ServicosDataset);
    ServicosDatasettipo_servico_codigo.Name := 'ServicosDatasettipo_servico_codigo';
    ServicosDatasettipo_servico_codigo.FieldName := 'tipo_servico_codigo';
    ServicosDatasettipo_servico_codigo.Size := 255;
    ServicosDatasetservico_comissao.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_comissao.Name := 'ServicosDatasetservico_comissao';
    ServicosDatasetservico_comissao.FieldName := 'servico_comissao';
    ServicosDatasetservico_comissao.DisplayFormat := '#,##0.00000';
    ServicosDatasetdepartamento_id.SetParentComponent(ServicosDataset);
    ServicosDatasetdepartamento_id.Name := 'ServicosDatasetdepartamento_id';
    ServicosDatasetdepartamento_id.FieldName := 'departamento_id';
    ServicosDatasetstatus_id.SetParentComponent(ServicosDataset);
    ServicosDatasetstatus_id.Name := 'ServicosDatasetstatus_id';
    ServicosDatasetstatus_id.FieldName := 'status_id';
    SetEvent(ServicosDatasetstatus_id, Self, 'OnGetText', 'ServicosDatasetstatus_idGetText');
    ServicosDatasetservico_preco_custo.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_preco_custo.Name := 'ServicosDatasetservico_preco_custo';
    ServicosDatasetservico_preco_custo.FieldName := 'servico_preco_custo';
    ServicosDatasetservico_preco_custo.DisplayFormat := '#,##0.00';
    ServicosDatasetservico_terceiro.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_terceiro.Name := 'ServicosDatasetservico_terceiro';
    ServicosDatasetservico_terceiro.FieldName := 'servico_terceiro';
    ServicosDatasetservico_terceiro.Required := True;
    ServicosDatasetservico_desconto_maximo.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_desconto_maximo.Name := 'ServicosDatasetservico_desconto_maximo';
    ServicosDatasetservico_desconto_maximo.FieldName := 'servico_desconto_maximo';
    ServicosDatasetservico_desconto_maximo.DisplayFormat := '#,##0.00000';
    ServicosDatasetservico_garantia.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_garantia.Name := 'ServicosDatasetservico_garantia';
    ServicosDatasetservico_garantia.FieldName := 'servico_garantia';
    ServicosDatasetservico_ciclo_vida.SetParentComponent(ServicosDataset);
    ServicosDatasetservico_ciclo_vida.Name := 'ServicosDatasetservico_ciclo_vida';
    ServicosDatasetservico_ciclo_vida.FieldName := 'servico_ciclo_vida';
    ServicosDatasetservicos_nacional_id.SetParentComponent(ServicosDataset);
    ServicosDatasetservicos_nacional_id.Name := 'ServicosDatasetservicos_nacional_id';
    ServicosDatasetservicos_nacional_id.FieldName := 'servicos_nacional_id';
    ServicosDatasetnbs_id.SetParentComponent(ServicosDataset);
    ServicosDatasetnbs_id.Name := 'ServicosDatasetnbs_id';
    ServicosDatasetnbs_id.FieldName := 'nbs_id';
    ServicosDatasetcodigo_issqn.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_issqn.Name := 'ServicosDatasetcodigo_issqn';
    ServicosDatasetcodigo_issqn.FieldName := 'codigo_issqn';
    ServicosDatasetcodigo_issqn.Size := 255;
    ServicosDatasetcodigo_tributacao_municipio.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_tributacao_municipio.Name := 'ServicosDatasetcodigo_tributacao_municipio';
    ServicosDatasetcodigo_tributacao_municipio.FieldName := 'codigo_tributacao_municipio';
    ServicosDatasetcodigo_tributacao_municipio.Size := 255;
    ServicosDatasetcodigo_interno.SetParentComponent(ServicosDataset);
    ServicosDatasetcodigo_interno.Name := 'ServicosDatasetcodigo_interno';
    ServicosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ServicosDatasetcodigo_interno.Required := True;
    ServicosDatasetexcluido.SetParentComponent(ServicosDataset);
    ServicosDatasetexcluido.Name := 'ServicosDatasetexcluido';
    ServicosDatasetexcluido.FieldName := 'excluido';
    ServicosDatasetinclusao.SetParentComponent(ServicosDataset);
    ServicosDatasetinclusao.Name := 'ServicosDatasetinclusao';
    ServicosDatasetinclusao.FieldName := 'inclusao';
    ServicosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetalteracao.SetParentComponent(ServicosDataset);
    ServicosDatasetalteracao.Name := 'ServicosDatasetalteracao';
    ServicosDatasetalteracao.FieldName := 'alteracao';
    ServicosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetexclusao.SetParentComponent(ServicosDataset);
    ServicosDatasetexclusao.Name := 'ServicosDatasetexclusao';
    ServicosDatasetexclusao.FieldName := 'exclusao';
    ServicosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ServicosDatasetunidadesigla.SetParentComponent(ServicosDataset);
    ServicosDatasetunidadesigla.Name := 'ServicosDatasetunidadesigla';
    ServicosDatasetunidadesigla.FieldName := 'unidade.sigla';
    ServicosDatasetnbsnbs.SetParentComponent(ServicosDataset);
    ServicosDatasetnbsnbs.Name := 'ServicosDatasetnbsnbs';
    ServicosDatasetnbsnbs.FieldName := 'nbs.nbs';
    SetEvent(ServicosDatasetnbsnbs, Self, 'OnGetText', 'ServicosDatasetnbsnbsGetText');
    ServicosDatasetnbsdescricao.SetParentComponent(ServicosDataset);
    ServicosDatasetnbsdescricao.Name := 'ServicosDatasetnbsdescricao';
    ServicosDatasetnbsdescricao.FieldName := 'nbs.descricao';
    ServicosDatasetserv_nacionalcTribNac.SetParentComponent(ServicosDataset);
    ServicosDatasetserv_nacionalcTribNac.Name := 'ServicosDatasetserv_nacionalcTribNac';
    ServicosDatasetserv_nacionalcTribNac.FieldName := 'serv_nacional.cTribNac';
    SetEvent(ServicosDatasetserv_nacionalcTribNac, Self, 'OnGetText', 'ServicosDatasetserv_nacionalcTribNacGetText');
    ServicosDatasetserv_nacionaldescricao.SetParentComponent(ServicosDataset);
    ServicosDatasetserv_nacionaldescricao.Name := 'ServicosDatasetserv_nacionaldescricao';
    ServicosDatasetserv_nacionaldescricao.FieldName := 'serv_nacional.descricao';
    XDataClientServicosGet.SetParentComponent(Self);
    XDataClientServicosGet.Name := 'XDataClientServicosGet';
    XDataClientServicosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientServicosGet, Self, 'OnLoad', 'XDataClientServicosGetLoad');
    XDataClientServicosGet.Left := 152;
    XDataClientServicosGet.Top := 328;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbservico_preco.AfterLoadDFMValues;
    lbcusto_fixo.AfterLoadDFMValues;
    lbunidade_id.AfterLoadDFMValues;
    lbtipo_servico_codigo.AfterLoadDFMValues;
    lbservico_comissao.AfterLoadDFMValues;
    lbstatus_id.AfterLoadDFMValues;
    lbservico_preco_custo.AfterLoadDFMValues;
    lbservico_terceiro.AfterLoadDFMValues;
    lbservico_desconto_maximo.AfterLoadDFMValues;
    lbservico_garantia.AfterLoadDFMValues;
    lbservico_ciclo_vida.AfterLoadDFMValues;
    lbservicos_nacional_id.AfterLoadDFMValues;
    lbnbs_id.AfterLoadDFMValues;
    lbcodigo_issqn.AfterLoadDFMValues;
    lbcodigo_tributacao_municipio.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edservico_preco.AfterLoadDFMValues;
    edunidade_id.AfterLoadDFMValues;
    edtipo_servico_codigo.AfterLoadDFMValues;
    edservico_comissao.AfterLoadDFMValues;
    edstatus_id.AfterLoadDFMValues;
    edservico_preco_custo.AfterLoadDFMValues;
    edservico_desconto_maximo.AfterLoadDFMValues;
    edservico_garantia.AfterLoadDFMValues;
    edservico_ciclo_vida.AfterLoadDFMValues;
    edservicos_nacional_id.AfterLoadDFMValues;
    ednbs_id.AfterLoadDFMValues;
    edcodigo_issqn.AfterLoadDFMValues;
    edcodigo_tributacao_municipio.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxcustofixo.AfterLoadDFMValues;
    cbxservicoterceiro.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ServicosDataset.AfterLoadDFMValues;
    ServicosDatasetid.AfterLoadDFMValues;
    ServicosDatasetaliado_id.AfterLoadDFMValues;
    ServicosDatasetdata_base_id.AfterLoadDFMValues;
    ServicosDatasetnome.AfterLoadDFMValues;
    ServicosDatasetservico_preco.AfterLoadDFMValues;
    ServicosDatasetcusto_fixo.AfterLoadDFMValues;
    ServicosDatasetunidade_id.AfterLoadDFMValues;
    ServicosDatasettipo_servico_codigo.AfterLoadDFMValues;
    ServicosDatasetservico_comissao.AfterLoadDFMValues;
    ServicosDatasetdepartamento_id.AfterLoadDFMValues;
    ServicosDatasetstatus_id.AfterLoadDFMValues;
    ServicosDatasetservico_preco_custo.AfterLoadDFMValues;
    ServicosDatasetservico_terceiro.AfterLoadDFMValues;
    ServicosDatasetservico_desconto_maximo.AfterLoadDFMValues;
    ServicosDatasetservico_garantia.AfterLoadDFMValues;
    ServicosDatasetservico_ciclo_vida.AfterLoadDFMValues;
    ServicosDatasetservicos_nacional_id.AfterLoadDFMValues;
    ServicosDatasetnbs_id.AfterLoadDFMValues;
    ServicosDatasetcodigo_issqn.AfterLoadDFMValues;
    ServicosDatasetcodigo_tributacao_municipio.AfterLoadDFMValues;
    ServicosDatasetcodigo_interno.AfterLoadDFMValues;
    ServicosDatasetexcluido.AfterLoadDFMValues;
    ServicosDatasetinclusao.AfterLoadDFMValues;
    ServicosDatasetalteracao.AfterLoadDFMValues;
    ServicosDatasetexclusao.AfterLoadDFMValues;
    ServicosDatasetunidadesigla.AfterLoadDFMValues;
    ServicosDatasetnbsnbs.AfterLoadDFMValues;
    ServicosDatasetnbsdescricao.AfterLoadDFMValues;
    ServicosDatasetserv_nacionalcTribNac.AfterLoadDFMValues;
    ServicosDatasetserv_nacionaldescricao.AfterLoadDFMValues;
    XDataClientServicosGet.AfterLoadDFMValues;
  end;
end;

end.
